import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Calendar from 'react-calendar';
import axios from 'axios';
import AccessSessionProp from '../../../commonComponents/propTypes/accessSessionProp';

function UpcomingSessionsCalendar({ upcomingSessions, navigation }) {
  const initialDateState = new Date(new Date().setHours(0, 0, 0, 0) + new Date().getTimezoneOffset());
  const [selectedDate, setSelectedDate] = useState(initialDateState);
  const [stateUpcomingSessions, setStateUpcomingSessions] = useState(upcomingSessions);
  // controls to add different classes depending on whether the event is single day or range of days
  const singleEventDays = [];
  const rangedEventDaysLeft = [];
  const rangedEventDaysInner = [];
  const rangedEventDaysRight = [];

  // maps sessions array
  const updateSessions = () => {
    stateUpcomingSessions.forEach(session => {
      const startDate = new Date(session.startDate);
      const endDate = new Date(session.endDate);
      // if same month set end day to endDate's day
      // if endDate's month is after endDay's, then
      const endDay = startDate.getMonth() === endDate.getMonth() ?
        endDate.getDate() :
        new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate();
      const startDay = startDate.getDate();
      // if it is a single day event, add it to control array if it isn't there already
      if (startDay === endDay) {
        if (
          !(singleEventDays.includes(startDay)) &&
          !(rangedEventDaysLeft.includes(startDay)) &&
          !(rangedEventDaysInner.includes(startDay)) &&
          !(rangedEventDaysRight.includes(startDay))
        ) {
          singleEventDays.push(startDay);
        }
      } else {
        // if it is a ranged event
        // if startDay or endDay are already marked as single day events, remove the mark
        if (singleEventDays.includes(startDay)) {
          const index = singleEventDays.indexOf(startDay);
          singleEventDays.splice(index, 1);
        }
        if (singleEventDays.includes(endDay)) {
          const index = singleEventDays.indexOf(endDay);
          singleEventDays.splice(index, 1);
        }

        // start with start and end date control
        // if no overlaps: start day goes to left control, end day goes to right control
        // and all days in between them are added to inner
        if (
          !(rangedEventDaysLeft.includes(startDay)) &&
          !(rangedEventDaysInner.includes(startDay)) &&
          !(rangedEventDaysRight.includes(startDay))
        ) {
          rangedEventDaysLeft.push(startDay);
        }
        if (
          !(rangedEventDaysLeft.includes(endDay)) &&
          !(rangedEventDaysInner.includes(endDay)) &&
          !(rangedEventDaysRight.includes(endDay))
        ) {
          rangedEventDaysRight.push(endDay);
        }

        // if left is on right and vice versa, remove and turn into inner
        if (rangedEventDaysRight.includes(startDay)) {
          const index = rangedEventDaysRight.indexOf(startDay);
          rangedEventDaysRight.splice(index, 1);
          if (!(rangedEventDaysInner.includes(startDay))) {
            rangedEventDaysInner.push(startDay);
          }
        }
        if (rangedEventDaysLeft.includes(endDay)) {
          const index = rangedEventDaysLeft.indexOf(endDay);
          rangedEventDaysLeft.splice(index, 1);
          if (!(rangedEventDaysInner.includes(endDay))) {
            rangedEventDaysInner.push(endDay);
          }
        }

        // if left or right are on inner, inner prevails so no changes needed
        // if left is in left and right are on right, no changes needed

        // add all days between startDay and endDay to inner
        let innerDay = startDay + 1;
        while (innerDay < endDay) {
          // if it is not in left , right or inner, add to inner
          if (
            !(rangedEventDaysLeft.includes(innerDay)) &&
            !(rangedEventDaysInner.includes(innerDay)) &&
            !(rangedEventDaysRight.includes(innerDay))
          ) {
            rangedEventDaysInner.push(innerDay);
          }
          // if it is in left of right add to inner and delete from left/right
          if (rangedEventDaysLeft.includes(innerDay)) {
            const index = rangedEventDaysLeft.indexOf(innerDay);
            rangedEventDaysLeft.splice(index, 1);
            if (!(rangedEventDaysInner.includes(innerDay))) {
              rangedEventDaysInner.push(innerDay);
            }
          }
          if (rangedEventDaysRight.includes(innerDay)) {
            const index = rangedEventDaysRight.indexOf(innerDay);
            rangedEventDaysRight.splice(index, 1);
            if (!(rangedEventDaysInner.includes(innerDay))) {
              rangedEventDaysInner.push(innerDay);
            }
          }

          // if this middle day is already marked as a single day event, remove mark
          if (singleEventDays.includes(innerDay)) {
            const index = singleEventDays.indexOf(innerDay);
            singleEventDays.splice(index, 1);
          }

          // else it is already on inner so no changes needed
          innerDay += 1;
        }
      }
    });
  };

  const getNewMonth = params => {
    axios.get('/api/access-session/list', {
      headers: {
        'Accept-Version': '1.0.0',
        'X-Gamification-API': 'Games',
      },
      params,
    })
      .then(({ data }) => {
        navigation(data.data);
        setStateUpcomingSessions(data.data);
        // date needs to be set to anywhere in the middle of the month being toggled
        // if we don't set, we will have issues with 30 and 31 day month difference
        setSelectedDate(new Date(new Date(params.dateEnd).setDate(15)));
        updateSessions();
      })
      .catch(err => {
        console.log(err);
      });
  };

  /* navigation bar cannot be changed, so it needs to be disabled and replace with a custom one */
    const handleNextMonthClick = () => {
    const currentMonth = selectedDate.getMonth();
    const currentDate = selectedDate;
    const params = {
      dateStart: new Date(currentDate.setMonth(currentMonth + 1)).setDate(0),
      dateEnd: new Date(currentDate.setMonth(currentMonth + 2)).setDate(0),
      upcoming: true,
    };
    getNewMonth(params);
  };
  const handlePreviousMonthClick = () => {
    const currentMonth = selectedDate.getMonth();
    const currentDate = selectedDate;
    const params = {
      dateStart: new Date(currentDate.setMonth(currentMonth - 1)).setDate(0),
      dateEnd: new Date(currentDate.setMonth(currentMonth)).setDate(0),
      upcoming: true,
    };
    getNewMonth(params);
  };

  updateSessions();
  return (
    <div data-testid="calendarContainer" className="row">
      <div className="col-12 mb-4">
        <div className="row">
          <div className="col-auto">
            {
              (selectedDate.getMonth() > new Date().getMonth() && (selectedDate.getFullYear() === new Date().getFullYear())
                || (selectedDate.getFullYear() > new Date().getFullYear()))
              && (
              <i
                data-testid="prevMonthButton"
                className="fa fa-angle-left calendar-navigation-buttons"
                onClick={handlePreviousMonthClick}
              />
            )}
          </div>
          <div className="col text-center">
            <h3>{selectedDate.toLocaleString('default', { month: 'long' })}</h3>
          </div>
          <div className="col-auto">
            <i
              data-testid="nextMonthButton"
              className="fa fa-angle-right calendar-navigation-buttons"
              onClick={handleNextMonthClick}
            />
          </div>
        </div>
      </div>
      <div className="col-12">
        <div className="calendar-container">
          <Calendar
            onChange={setSelectedDate}
            value={selectedDate}
            showNavigation={false}
            tileDisabled={() => true}
            tileClassName={({ activeStartDate, date }) => {
              if (date.getMonth() === activeStartDate.getMonth()) {
                // use control lists to assign classes
                if (singleEventDays.includes(date.getDate())) {
                  return 'active-calendar-colors single-event';
                }
                if (rangedEventDaysLeft.includes(date.getDate())) {
                  return 'active-calendar-colors ranged-event-left';
                }
                if (rangedEventDaysRight.includes(date.getDate())) {
                  return 'active-calendar-colors ranged-event-right';
                }
                if (rangedEventDaysInner.includes(date.getDate())) {
                  return 'active-calendar-colors';
                }
                return 'enabled-date';
              }
              return '';
            }}
          />
        </div>
      </div>
    </div>
  );
}

UpcomingSessionsCalendar.propTypes = {
  upcomingSessions: PropTypes.arrayOf(PropTypes.shape(AccessSessionProp.propType)).isRequired,
  navigation: PropTypes.func.isRequired,
};

export default UpcomingSessionsCalendar;
